/* Brother Bruno Direct — add to cart confirmation.
   Replaces the stock Supply ajax modal, which rendered off-screen and invisible.
   Intercepts any /cart/add form, adds via the Cart API, updates every cart count
   and shows a visible confirmation. If anything goes wrong the form is submitted
   normally so the customer always ends up on the cart page. */
(function () {
  'use strict';

  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  var toast;

  function build() {
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'bbd-added';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<button class="bbd-added__x" type="button" aria-label="Close">&times;</button>' +
      '<p class="bbd-added__eyebrow">Added to your cart</p>' +
      '<div class="bbd-added__row">' +
      '<img class="bbd-added__img" alt="" width="64" height="64">' +
      '<div class="bbd-added__meta"><strong class="bbd-added__name"></strong>' +
      '<span class="bbd-added__opts"></span>' +
      '<span class="bbd-added__price"></span></div></div>' +
      '<p class="bbd-added__sub">Cart subtotal <b></b></p>' +
      '<div class="bbd-added__btns">' +
      '<a class="bbd-added__cart" href="/cart">View cart</a>' +
      '<a class="bbd-added__go" href="/checkout">Checkout</a>' +
      '</div>';
    document.body.appendChild(toast);
    toast.querySelector('.bbd-added__x').addEventListener('click', hide);
    return toast;
  }

  var timer;
  function show(item, cart) {
    var t = build();
    var img = t.querySelector('.bbd-added__img');
    if (item.image) {
      img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
      img.style.display = '';
    } else {
      img.style.display = 'none';
    }
    t.querySelector('.bbd-added__name').textContent = item.product_title || item.title || 'Item';
    var opts = (item.options_with_values || [])
      .filter(function (o) { return o.value && o.value !== 'Default Title'; })
      .map(function (o) { return o.value; })
      .join(' · ');
    t.querySelector('.bbd-added__opts').textContent = opts;
    t.querySelector('.bbd-added__price').textContent = money(item.final_line_price || item.price || 0);
    t.querySelector('.bbd-added__sub b').textContent = money(cart && cart.total_price ? cart.total_price : 0);
    t.classList.add('is-on');
    clearTimeout(timer);
    timer = setTimeout(hide, 9000);
  }

  function fail(message) {
    var t = build();
    t.querySelector('.bbd-added__eyebrow').textContent = message || 'That could not be added';
    t.classList.add('is-on');
    clearTimeout(timer);
    timer = setTimeout(hide, 6000);
  }

  function hide() {
    if (toast) toast.classList.remove('is-on');
  }

  function counts(n) {
    var els = document.querySelectorAll('.cart-count, [data-bbd-cart-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      els[i].classList.toggle('hidden-count', n === 0);
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (form.hasAttribute('data-bbd-native')) return;

    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }

    var restore = function () {
      if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); if (label !== null) btn.innerHTML = label; }
    };

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          restore();
          fail(res.data && res.data.description ? res.data.description : 'That item could not be added');
          return;
        }
        var item = res.data;
        return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            restore();
            counts(cart.item_count);
            show(item, cart);
          });
      })
      .catch(function () {
        // Last resort: let Shopify handle it the old fashioned way.
        form.setAttribute('data-bbd-native', '');
        form.submit();
      });
  }, true);
})();
